import { ChevronLeft } from "lucide-react";
import * as React from "react";

import { PaginationLink } from "@/components/pagination/PaginationLink";
import { NormalText } from "@/components/text/NormalText";
import { cn } from "@/utils/cn";

export function PaginationPrevious({
  className,
  ...props
}: React.ComponentProps<typeof PaginationLink>) {
  return (
    <PaginationLink
      aria-label="Go to previous page"
      size="default"
      className={cn("gap-1 pl-2.5", className)}
      {...props}
    >
      <ChevronLeft className="h-4 w-4" />
      <NormalText elementType="span" className="hidden md:block">
        Previous
      </NormalText>
    </PaginationLink>
  );
}
PaginationPrevious.displayName = "PaginationPrevious";
